import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  OtpVery_img,
  Successfullly_Created,
  Right_Arrow,
} from '../../../assets/images/index';
import { Link, useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import OTP from '../../../components/OTP_Component';
import {
  handleCustomerOTPVerify,
  handleLogin,
  handleCustomerSignup,
  handleCustomerSigninVerify,
  handleCustomerLogin,
  handleCustomerSignupNo,
} from '../../../stores/services/authApis/index';
import { hashPassword } from '../../../constant/constant';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setLoginAction } from '../../../stores/actionTypes/authActions/index';
import { useLocation } from 'react-router-dom';
import DeleteIcon from '../../../assets/images/deletePopup.svg';

const OtpVery = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const mobileNo = state?.mobileNo;
  const fromPage = state?.page;
  const signUpFormData = state?.formData;
  const dispatch = useDispatch();
  const [otp, setOtp] = React.useState('');
  const [accountCreated, setAccountCreated] = useState(false);
  const showAlert = useAlert();
  const [timer, setTimer] = useState(30); // Set initial timer value
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [handleMultipleApi, setHandleMultipleApi] = useState(true);

  //edit mobile no
  const handleEditConfirm = () => {
    if (fromPage === 'signUp') {
      navigate('/signup', { state: { formData: signUpFormData } });
    } else {
      navigate('/customerLogin', { state: { mobileNo } });
    }
    setOpenEditDialog(false);
  };
  useEffect(() => {
    startTimer();
    !mobileNo && navigate('/customerLogin');
  }, []);

  const startTimer = () => {
    setIsTimerActive(true);
    setTimer(30); // Reset timer to 30 seconds
    setIsTimerActive(true);
  };

  useEffect(() => {
    let interval: any;

    if (isTimerActive) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsTimerActive(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer, isTimerActive]);

  const signup = async (data: any) => {
    const payload = {
      firstName: data.firstname,
      lastName: data.lastname,
      email: data.email,
      mobileNo: data.mobilenumber,
    };
    await handleCustomerSignup(payload)
      .then((response) => {
        showAlert('SignUp Successfully', 'success');
        setAccountCreated(true);
      })
      .catch((error) => {
        console.log(error.message, 'error');
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const handleSubmit = async () => {
    if (otp.trim().length !== 6 || !handleMultipleApi) return; // Exit if OTP is not 6 digits or multiple API calls are blocked
    setHandleMultipleApi(false);
    const payload = {
      mobileNo: mobileNo,
      otp: Number(otp),
    };

    if (fromPage === 'signUp') {
      await handleCustomerOTPVerify(payload)
        .then((response) => {
          showAlert('verify Successfully', 'success');
          signup(signUpFormData);
          setHandleMultipleApi(true);
        })
        .catch((error) => {
          showAlert(error?.response?.data?.error || error?.message, 'error');
          setHandleMultipleApi(true);
        });
    } else {
      await handleCustomerSigninVerify(payload)
        .then((response) => {
          const { error, data } = response.data;
          if (error) {
            showAlert('Invalid credential', 'error');
            return;
          }
          showAlert('Login Successfully', 'success');
          localStorage.setItem('ICEMAKE', data);
          dispatch(setLoginAction(data));
          navigate('/equipment/ownedequipment');
          // login();
          setHandleMultipleApi(true);
        })
        .catch((error) => {
          showAlert(error?.response?.data?.error || error?.message, 'error');
          setHandleMultipleApi(true);
        });
    }
  };

  const customerLogin = async () => {
    await handleCustomerLogin({ mobileNo: mobileNo })
      .then((response) => {
        showAlert('Resend OTP Successfully', 'success');
        startTimer();
      })
      .catch((error) => {
        showAlert('Resend OTP failed', 'error');
      });
  };

  const signupVerify = async () => {
    await handleCustomerSignupNo({ mobileNo: mobileNo })
      .then((response) => {
        showAlert('Resend OTP Successfully', 'success');
        startTimer();
      })
      .catch((error) => {
        showAlert(error.response.data.error || error.message, 'error');
      });
  };

  const handleResendOtp = () => {
    if (fromPage === 'signUp') {
      signupVerify();
    } else {
      customerLogin();
    }
  };
  return (
    <>
      {accountCreated ? (
        <>
          <img
            src={Successfullly_Created}
            alt="Successfully_Created"
            width="100%"
          />
          <div className="account_created_succefully">
            <h4>Your account created successfully!</h4>
            <Button onClick={() => navigate('/customerLogin')}>
              Go To SignIn <img src={Right_Arrow} alt="Right_Arrow" />
            </Button>
          </div>
        </>
      ) : (
        <section className="verification_container">
          <div className="verification_heading">
            <h4>OTP verification</h4>
            <h6>
              Enter the verification code sent on (+91)*********
              {mobileNo?.slice(6, 10)}.
              <span>
                <Button onClick={() => setOpenEditDialog(true)}>Edit</Button>
              </span>
            </h6>
          </div>

          <div className="verification_container_img">
            <img src={OtpVery_img} width="100%" alt="verification" />
          </div>

          <div className="verification_input">
            <OTP
              value={otp}
              onChange={setOtp}
              onEnter={handleSubmit}
              length={6}
            />

            <h5>
              Didn’t receive code?
              {isTimerActive ? (
                <span> Resend OTP in {timer}s</span>
              ) : (
                <span>
                  <Button onClick={handleResendOtp}> Resend OTP</Button>
                </span>
              )}
            </h5>
          </div>

          <div className="verification_submit">
            <Button disabled={otp.trim().length !== 6} onClick={handleSubmit}>
              Verify & Proceed
            </Button>
          </div>
        </section>
      )}

      <Dialog
        className="popup mobile_edit-popup"
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title" className="text-center">
          <img src={DeleteIcon} alt={`Edit Moile icon`} width="32" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            className="text-center"
            id="delete-dialog-description"
          >
            Are you sure you want to <br /> change this mobile number? <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button
            onClick={() => setOpenEditDialog(false)}
            color="primary"
            variant="contained"
            className="delete-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditConfirm}
            color="primary"
            variant="contained"
            className="mobile_edit-btn"
          >
            Edit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect((assets) => assets, {
  handleLogin,
})(OtpVery);
